export default "__VITE_ASSET__BBXt8w3p__"